import React, { useState, useEffect } from "react";
import { Layout } from "../components/Layout";
import Breadcrumb from "../components/Breadcrumb";
import {
  getCustomers,
  createCustomer,
  updateCustomer
} from "../services/customerService";
import CustomerTable from "../components/CustomerTable";
import CustomerForm from "../components/CustomerForm";
import {
  AddButton,
  Container,
  Title,
  TableWrapper,
  HeaderRow,
  PaginationButton,
  PageCounter,
  SearchInput,
  StatusSelect
} from "../styles/StyledComponents";

// Função para limpar payload
const sanitizeCustomerPayload = data => {
  const { _id, __v, createdAt, updatedAt, equipmentCount, ...cleaned } = data;
  return cleaned;
};

const CustomerManagementPage = () => {
  const [customers, setCustomers] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("Ativo");

  const [newCustomer, setNewCustomer] = useState({
    status: "Lead - Sem contrato",
    tipoContrato: "S - Service",
    createdAt: "",
    name: "",
    cnpj: "",
    type: "Residencial",
    address: "",
    number: "",
    neighborhood: "",
    postalCode: "",
    city: "",
    state: "",
    latitude: "",
    longitude: "",
    contactName: "",
    contactPhone: "",
    contactEmail: "",
    contractNumber: "",
    equipment: []
  });

  const fetchCustomers = async () => {
    try {
      const data = await getCustomers(
        currentPage,
        10,
        searchQuery,
        statusFilter
      );
      setCustomers(data.customers);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error("Erro ao carregar clientes:", error);
    }
  };

  useEffect(
    () => {
      fetchCustomers();
    },
    [currentPage, searchQuery, statusFilter]
  );

  const handlePageChange = newPage => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleStatusChange = e => {
    setStatusFilter(e.target.value);
    setCurrentPage(1);
  };

  const handleInputChange = e => {
    const name = e.target.name || e.currentTarget.name;
    const value = e.target.value;

    if (!name) {
      console.warn("Campo sem name detectado:", e);
      return;
    }

    setNewCustomer(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFormSubmit = async e => {
    e.preventDefault();

    const payload = sanitizeCustomerPayload(newCustomer);
    console.log("Payload final enviado:", payload);

    try {
      if (editingCustomer) {
        await updateCustomer(editingCustomer._id, payload);
      } else {
        await createCustomer(payload);
      }

      setFormVisible(false);
      setEditingCustomer(null);
      setCurrentPage(1);
      fetchCustomers();
    } catch (error) {
      console.error("Erro ao salvar cliente:", error);
    }
  };

  const handleEdit = customer => {
    setEditingCustomer(customer);
    setNewCustomer({
      ...customer,
      tipoContrato: customer.tipoContrato || "S - Service"
    });
    setFormVisible(true);
    console.log("Edit:", customer);
  };

  const handleAddNew = () => {
    setEditingCustomer(null);
    setNewCustomer({
      status: "Lead - Sem contrato",
      tipoContrato: "S - Service",
      name: "",
      cnpj: "",
      type: "Residencial",
      address: "",
      number: "",
      neighborhood: "",
      postalCode: "",
      city: "",
      state: "",
      latitude: "",
      longitude: "",
      contactName: "",
      contactPhone: "",
      contactEmail: "",
      contractNumber: "Sem Número",
      equipment: [
        {
          equipmentNumber: "",
          apelido: "",
          type: "Social",
          manufacturer: "thyssenkrupp"
        }
      ]
    });
    setFormVisible(true);
  };

  return (
    <Layout pageTitle="Administração de Clientes">
      <Breadcrumb items={["Home", "Clientes", "Lista de Clientes"]} />
      <Container>
        <TableWrapper>
          <HeaderRow>
            <Title>Cadastro de Clientes</Title>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <SearchInput
                type="text"
                placeholder="Buscar por nome ou endereço"
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <StatusSelect value={statusFilter} onChange={handleStatusChange}>
                <option value="Todos">Todos</option>
                <option value="Ativo">Ativo</option>
                <option value="Suspenso">Suspenso</option>
                <option value="Cancelado">Cancelado</option>
                <option value="Lead - Sem contrato">Lead - Sem contrato</option>
              </StatusSelect>
              <AddButton onClick={handleAddNew}>+ Novo Cliente</AddButton>
            </div>
          </HeaderRow>
          <CustomerTable customers={customers} onEdit={handleEdit} />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "16px"
            }}
          >
            <PaginationButton
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Anterior
            </PaginationButton>
            <PageCounter>
              Página {currentPage} de {totalPages}
            </PageCounter>
            <PaginationButton
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Próxima
            </PaginationButton>
          </div>
        </TableWrapper>
        <CustomerForm
          visible={formVisible}
          customer={newCustomer}
          onChange={handleInputChange}
          onSubmit={handleFormSubmit}
          onCancel={() => setFormVisible(false)}
          isEditing={!!editingCustomer}
        />
      </Container>
    </Layout>
  );
};

export default CustomerManagementPage;
